//#region src/components/progress/progress-state.ts
var e = (e, t, n) => {
	let r = Number.isFinite(t) && t > 0 ? t : 100, i = e === null ? null : n === "complete" ? r : Number.isFinite(e) ? Math.min(r, Math.max(0, e)) : 0;
	return {
		maximum: r,
		current: i,
		percentage: i === null ? null : i / r * 100
	};
}, t = {
	active: "pf:text-blue-700",
	complete: "pf:text-green-700",
	failed: "pf:text-red-700"
};
//#endregion
export { e as normalizeProgress, t as progressClassNames };
